import { SearchDocumentType, } from '../../api/api.types';
import { getSearchResults } from './searchResults';
var PAGE_SIZE = 10;
export var SEARCH_RESULTS_EMPTY_RESPONSE = {
    documents: [],
    nextPage: { total: 0, skip: 0, limit: PAGE_SIZE },
    facets: [],
};
var BASIC_TOTALS = [
    {
        facetValue: SearchDocumentType.Pages,
        count: 73,
    },
    {
        facetValue: SearchDocumentType.Products,
        count: 64,
    },
    {
        facetValue: SearchDocumentType.Blogs,
        count: 58,
    },
];
export function getSearchResultsResponse(searchRequest, documentTypes) {
    var availableDocumentTypes = new Set(documentTypes);
    var documentTypeFacets = BASIC_TOTALS.filter(function (f) {
        return availableDocumentTypes.has(f.facetValue);
    });
    if (!documentTypeFacets.length) {
        documentTypeFacets = [
            {
                facetValue: searchRequest.documentType || SearchDocumentType.Pages,
                count: 77,
            },
        ];
    }
    var currentDocumentTypeFacet = searchRequest.documentType
        ? documentTypeFacets.find(function (f) { return f.facetValue === searchRequest.documentType; })
        : null;
    var totalCount = currentDocumentTypeFacet
        ? currentDocumentTypeFacet.count
        : documentTypeFacets.reduce(function (acc, f) { return acc + f.count; }, 0);
    var skip = (searchRequest.paging && searchRequest.paging.skip) || 0;
    var limit = Math.min(totalCount - skip, (searchRequest.paging && searchRequest.paging.limit) || PAGE_SIZE);
    return {
        documents: getSearchResults({
            documentType: searchRequest.documentType || SearchDocumentType.All,
            limit: limit,
            skip: skip,
            query: searchRequest.query,
        }),
        nextPage: { total: totalCount, skip: 0, limit: limit },
        facets: [
            {
                facet: 'document_type',
                facets: documentTypeFacets,
            },
        ],
    };
}
//# sourceMappingURL=searchResultsResponse.js.map